import {useEffect, useRef} from 'react';
import {useHistory, useLocation} from 'react-router-dom';

/**
 * Opens the row named by ?id= once its list has loaded, then strips the parameter.
 *
 * The home page search links to /owners?id=77 and the like; this is the receiving end.
 * The parameter is cleared after opening so closing the dialog and pressing Edit again
 * behaves normally, and a refresh does not reopen what the user just closed.
 *
 * @param rows the list the id refers to; undefined while the query is in flight
 * @param openRow called once with the matching row
 */
const useLinkedRow = (rows, openRow) => {
  const history = useHistory();
  const location = useLocation();
  const handled = useRef(null);

  // Held in a ref so a handler redefined on every render does not retrigger the effect.
  const openRowRef = useRef(openRow);
  openRowRef.current = openRow;

  useEffect(() => {
    const id = new URLSearchParams(location.search).get('id');
    if (!id || !rows || handled.current === id) return;

    const row = rows.find((candidate) => String(candidate.id) === id);
    if (!row) return;

    handled.current = id;
    history.replace(location.pathname);
    openRowRef.current(row);
  }, [location.search, location.pathname, rows, history]);
};

export default useLinkedRow;
